const emptyState = {
  showBack: false
};

export const sideBarReducer = (state = emptyState, { type, payload }) => {
  switch (type) {
    case 'TOGGLE_BACK':
      return {
        ...state,
        showBack: payload
      };

    default:
      return state;
  }
};
